import { render, staticRenderFns } from "./ProfileInfoForm.vue?vue&type=template&id=12dc95fc&"
import script from "./ProfileInfoForm.vue?vue&type=script&lang=js&"
export * from "./ProfileInfoForm.vue?vue&type=script&lang=js&"
import style0 from "./ProfileInfoForm.vue?vue&type=style&index=0&id=12dc95fc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports